import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'

const previousActivityService = {
  getPreviousActivities: async (user, processTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/previous-activity/${processTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },

  revertActivity: async (user, processTemplateId, processReferenceNum) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/previous-activity/revert`,
        {
          process_template_id: processTemplateId,
          process_reference_num: processReferenceNum,
        },
        getAxiosOptions(user)
      )
    ).data
  },
}

export default previousActivityService